module.exports = __webpack_public_path__ + "img/purple-logo.9fe62e2b.png";